import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'dynamic-columns',
  templateUrl: './dynamic-columns.component.html',
  styleUrls: ['./dynamic-columns.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DynamicColumnsComponent implements OnInit {
  @Input() localStorageId :string = '';
  @Input() configuration :Record<string, DynamicColumnConfig> = {};
  @Output() changeConfiguration = new EventEmitter<{
    config :Record<string, DynamicColumnConfig>;
    refresh :boolean;
  }>();
  @Output() updateColumnEvent = new EventEmitter<{
    updatedColumn :string;
    columnConfig :Record<string, DynamicColumnConfig>;
  }>();

  private prependLS :string = 'luminous_dynamicColumn_';

  constructor(private permissionsService: NgxPermissionsService) {}

  ngOnInit() {
    if (!this.localStorageId) {
      throw Error('[DynamicColumnsComponent] requires "localStorageId" property.');
    }
    this.resolvePermissions();
    this.hydrate();
  }

  toggle(key :string) :void {
    this.configuration[key].active = !this.configuration[key].active;
    this.save();
    this.changeConfiguration.emit({
      config: this.configuration,
      refresh: true,
    });
    this.updateColumnEvent.emit({
      updatedColumn: key,
      columnConfig: this.configuration,
    });
  }

  sortList() :number {
    return 0;
  }

  columnActiveCount() :number {
    return Object.keys(this.configuration).filter(
      (key) => this.configuration[key].active,
    ).length;
  }

  hydrate() {
    try {
      const savedConfig = JSON.parse(
        localStorage.getItem(this.prependLS + this.localStorageId),
      );
      Object.keys(savedConfig).forEach((key) => {
        if (this.configuration[key]) {
          this.configuration[key].active = savedConfig[key].active;
        }
      });
      this.changeConfiguration.emit({
        config: this.configuration,
        refresh: false,
      });
    } catch (e) {}
  }

  save() {
    localStorage.setItem(
      this.prependLS + this.localStorageId,
      JSON.stringify(this.configuration),
    );
  }

  private resolvePermissions(): void {
    Object.keys(this.configuration).forEach((key) => {
      const permissions = this.configuration[key].permissions;
      if (!permissions || permissions.length === 0) {
        this.configuration[key].hasPermission = true;
      } else {
        this.permissionsService.hasPermission(permissions).then((allowed) => {
          this.configuration[key].hasPermission = allowed;
        });
      }
    });
  }
}
